import { Select, Space, Typography } from 'antd'
import { useHistogramConfiguration } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { FC } from 'react'

const { Text } = Typography

export const HistoSortConfigView: FC = () => {
  const { sortDirection, setSortDirection } = useHistogramConfiguration()
  return (
    <>
      {!!setSortDirection && (
        <Space
          style={{
            flexWrap: 'wrap',
            gap: '5px',
          }}>
          <Text>Sort: </Text>
          {!!setSortDirection && (
            <Select
              options={[
                { value: 'asc', label: 'Ascending' },
                { value: 'desc', label: 'Descending' },
              ]}
              defaultValue={sortDirection}
              value={sortDirection}
              onChange={setSortDirection}
              style={{ width: 150 }}
            />
          )}
        </Space>
      )}
    </>
  )
}
